import { z } from 'zod'

import { FormError } from '@forto-dev/platform-localisation'

export const ResetPasswordSchema = z
  .object({
    password: z.string().min(8, FormError.MIN_PASSWORD).max(128, FormError.MAX_PASSWORD),
    confirmPassword: z.string().min(8, FormError.MIN_PASSWORD).max(128, FormError.MAX_PASSWORD),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: FormError.PASSWORD_MISMATCH,
    path: ['confirmPassword'],
  })

export type ResetPasswordSchemaType = z.infer<typeof ResetPasswordSchema>
